import { WALLET_DETAILS } from '../actionTypes';

const initialState = {
  walletDetails: [],
  cardDetails: [],
  walletDetailsStatus: undefined,
  walletDetailsError: undefined,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case WALLET_DETAILS.FETCH:
      return {
        ...state,
        walletDetailsStatus: 'STARTED',
      };
    case WALLET_DETAILS.SUCCESS:
      return {
        ...state,
        walletDetails: action.payload,
        walletDetailsStatus: 'SUCCESS',
      };
    case WALLET_DETAILS.FAILED:
      return {
        ...state,
        walletDetailsError: action.payload,
        walletDetailsStatus: 'FAILED',
      };
    case WALLET_DETAILS.FETCH_WALLETDETAILS_SUCCESS:
      return {
        ...state,
        walletDetails: action.payload,
      };
    case WALLET_DETAILS.FETCH_CARDS_SUCCESS:
      return {
        ...state,
        cardDetails: action.payload,
      };
    default:
      return state;
  }
};
